module.exports = __webpack_public_path__ + "static/1-07b319e6fd8ed28d92706b4476ec6d8c.jpg";